import React, { Component } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { Input, Radio, Button, Collapse } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { Image, StepsToGetQuote, PopularProducts, Search, Spin } from '../../components';
import { withRedux } from '../../hoc';
import { getServiceUrl } from '../../utils';
import { getProductsAction } from '../../actions/product/products';

const SearchInput = Input.Search;
const RadioGroup = Radio.Group;
const Panel = Collapse.Panel;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    product: _.get(state, 'product')
  };
};

const actions = {
  getProductsAction
};

@withRouter
@withRedux(mapStateToProps, actions)
export default class ProductContainer extends Component {
  constructor(props) {
    super(props);
    this.brandRadioRef = React.createRef();
    this.categoryRadioRef = React.createRef();
    this.searchInputRef = React.createRef();
  }
  componentDidMount() {
    this.handleReceiveInputValue(this.props.location.search);
    this.props.actions.getProductsAction();
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.location.search, nextProps.location.search)) {
      this.handleReceiveInputValue(nextProps.location.search);
    }
  }
  handleReceiveInputValue = search => {
    const parsed = queryString.parse(search);
    const brand = _.toInteger(_.get(parsed, 'brand'));
    const category = _.toInteger(_.get(parsed, 'category'));
    const q = _.get(parsed, 'q', '');
    this.searchInputRef.current.input.input.value = q;
    this.brandRadioRef.current.state.value = brand;
    this.categoryRadioRef.current.state.value = category;
  };
  search = ({ searchValue = '', searchBrand = '', searchCategory = '' }) => {
    const params = {
      brand: searchBrand,
      category: searchCategory,
      q: searchValue,
      page: 1
    };
    const stringified = queryString.stringify(params);
    this.props.history.push({
      pathname: '/product',
      search: `?${stringified}`
    });
  };
  handleClickSearch = () => {
    const searchValue = this.searchInputRef.current.input.input.value;
    const searchBrand = this.brandRadioRef.current.state.value;
    const searchCategory = this.categoryRadioRef.current.state.value;
    this.search({ searchValue, searchBrand, searchCategory });
  };
  handleInputSearch = value => {
    const searchBrand = this.brandRadioRef.current.state.value;
    const searchCategory = this.categoryRadioRef.current.state.value;
    this.search({ searchValue: value, searchBrand, searchCategory });
  };
  handleClickClear = () => {
    this.search({});
  };
  render() {
    const { t } = this.props;
    const id = _.get(this.props, 'match.params.id');
    let product = null;
    if (id) product = this.props.product.products.data[id];
    const brandsLoading = _.get(this.props, 'product.brands.loading');
    const categoriesLoading = _.get(this.props, 'product.categories.loading');
    return (
      <div className="product-page container-wrapper">
        <div className="nav-bar">
          <div className="desktop-mode">
            <div className="container">
              <div className="row align-items-center no-gutters">
                <div className="col-md-3">
                  <div className="search-input">
                    <SearchInput
                      ref={this.searchInputRef}
                      placeholder={t('Search Code e.g.SKR20')}
                      onSearch={this.handleInputSearch}
                    />
                  </div>
                </div>
                <div className="col-md-9">
                  <ul className="breadcrumb">
                    <li>
                      <Link to="/product">{t('Products')}</Link>
                    </li>
                    {id && (
                      <React.Fragment>
                        <li>
                          <span>></span>
                        </li>
                        <li>
                          <span>{t(_.get(product, 'name'))}</span>
                        </li>
                      </React.Fragment>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-mode">
            <div className="search-block">
              <Search.Main />
            </div>
            <ul className="breadcrumb">
              <li>
                <Link to="/product">{t('Products')}</Link>
              </li>
              {id && (
                <React.Fragment>
                  <li>
                    <span>></span>
                  </li>
                  <li className="active">
                    <span>{t(_.get(product, 'name'))}</span>
                  </li>
                </React.Fragment>
              )}
            </ul>
          </div>
        </div>
        <div className="content-block">
          <div className="container">
            <div className="row row-1 no-gutters">
              <div className="col-md-3">
                <div className="search-block">
                  <div className="filter-brand">
                    <Collapse defaultActiveKey={['filter-brand']}>
                      <Panel header={t('Brands')} key="filter-brand">
                        <div className="items">
                          <Spin spinning={brandsLoading}>
                            <RadioGroup ref={this.brandRadioRef}>
                              {_.map(this.props.product.brands.data, brand => {
                                const { id, name, logo } = brand;
                                const full_file_path = `${getServiceUrl()}/${_.get(logo, 'path')}`;
                                return (
                                  <Radio key={id} value={id}>
                                    <Image src={full_file_path} alt={t(name)} />
                                  </Radio>
                                );
                              })}
                            </RadioGroup>
                          </Spin>
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                  <div className="filter-category">
                    <Collapse defaultActiveKey={['filter-category']}>
                      <Panel header={t('Categories')} key="filter-category">
                        <div className="items">
                          <Spin spinning={categoriesLoading}>
                            <RadioGroup ref={this.categoryRadioRef}>
                              {_.map(this.props.product.categories.data, category => {
                                const { id, name } = category;
                                return (
                                  <Radio key={id} value={id}>
                                    {t(name)}
                                  </Radio>
                                );
                              })}
                            </RadioGroup>
                          </Spin>
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                  <div className="filter-btn">
                    <Button type="dashed" onClick={this.handleClickClear}>
                      {t('Clear')}
                    </Button>
                    <Button onClick={this.handleClickSearch}>{t('Search')}</Button>
                  </div>
                </div>
                <div className="recently-searched-items">
                  <div className="title">{t('Recently Searched Items')}</div>
                  <ul className="items">
                    {_.map(this.props.product.products.recentlyView, (productId, key) => {
                      const recently_product = _.find(this.props.product.products.data, {
                        id: productId
                      });
                      const full_file_path = `${getServiceUrl()}/${_.get(recently_product, 'image.path')}`;
                      return (
                        <li key={key}>
                          <Link to={`/product/detail/${productId}`}>
                            <div className="image">
                              <Image src={full_file_path} alt={t(_.get(recently_product, 'name'))} />
                            </div>
                            <div className="name">{t(_.get(recently_product, 'name'))}</div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="col-md-9">{this.props.children}</div>
            </div>
            <div className="popular-products-block">
              <PopularProducts />
            </div>
          </div>
          <div className="steps-quote-block">
            <StepsToGetQuote />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Product/Container.js